var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { DownloadIcon } from '../atoms/Icons';
import Dialog from '../atoms/Dialog';
import CheckboxGroup from '../atoms/CheckboxGroup';
import { camelize } from '../../utils/camelize';
import useDownload from '../../hooks/useDownload';
var DownloadRoastersCSVButton = function (_a) {
    var _b = _a.params, params = _b === void 0 ? {} : _b;
    var t = useTranslation().t;
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var _d = React.useState(__spreadArray([], filterColumns, true)), columns = _d[0], setColumns = _d[1];
    var csvParams = React.useMemo(function () {
        var excludeColumns = filterColumns.filter(function (column) { return columns.indexOf(column) < 0; });
        return __assign(__assign({}, params), { exclude_columns: excludeColumns });
    }, [params, columns]);
    var filterColumnItems = React.useMemo(function () {
        return filterColumns.map(function (column) {
            var label = t("params.roaster.".concat(camelize(column)), '') ||
                t("params.".concat(camelize(column)));
            return { label: label, value: column };
        });
    }, [t]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: function () { return setOpen(true); }, "aria-label": "CSV Download", size: "large" },
            React.createElement(Tooltip, { title: t('buttons.downloadCsv') || '' },
                React.createElement(DownloadIcon, null))),
        React.createElement(Dialog, { open: open, onClose: function () { return setOpen(false); }, actions: React.createElement(DownloadButton, { key: JSON.stringify(csvParams), params: csvParams, disabled: columns.length === 0 }) },
            React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between" },
                React.createElement(Typography, { variant: "h6" }, t('messages.selectColumns')),
                React.createElement(Box, null,
                    React.createElement(Button, { onClick: function () { return setColumns(__spreadArray([], filterColumns, true)); }, style: {
                            marginRight: 2,
                        } }, t('buttons.selectAll')),
                    React.createElement(Button, { onClick: function () { return setColumns([]); } }, t('buttons.deselectAll')))),
            React.createElement(CheckboxGroup, { name: "column", value: columns, items: filterColumnItems, onChange: function (values) { return setColumns(values); } }))));
};
export default DownloadRoastersCSVButton;
var DownloadButton = function (_a) {
    var params = _a.params, disabled = _a.disabled;
    var t = useTranslation().t;
    var _b = useDownload({
        path: '/api/roasters.csv',
        downloadFilename: 'roasters.csv',
        params: params,
    }), downloading = _b.downloading, handleDownload = _b.handleDownload;
    return (React.createElement(Button, { onClick: handleDownload, disabled: disabled || downloading, variant: "contained" }, t('buttons.downloadCsv')));
};
var filterColumns = [
    'id',
    'community_manager',
    'customer_type',
    'store_type',
    'company',
    'store_name',
    'email',
    'country',
    'office',
    'country_calling_code',
    'phone',
    'lastname',
    'firstname',
    'name_kana',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'building',
    'roaster_maker',
    'roaster_max_capacity',
    'roasted_per_month',
    'store_count',
    'have_ec_shop',
    'business_type',
    "is_q_grader",
    'community_engagement',
    'typica_share_ratio',
    'trade_countries',
    'created_at',
];
